import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Event } from '@/types/event'

export function getEvent(eventUuid: string): Promise<AxiosResponse<Event>> {
  return instance.get(`/event/${eventUuid}`)
}
